<div class="modal-header justify-content-between">
  <h4 class="modal-title">Approve Planogram</h4>
  <button class="btn btn-link" (click)="cancel()">
    <i class="bi bi-x-lg"></i>
  </button>
</div>

<div class="modal-body p-4">
  <div *ngIf="loading" class="text-center p-5">
    <div class="spinner-border text-primary" role="status"></div>
    <p class="mt-2 text-muted">Checking for existing approved planograms...</p>
  </div>

  <div *ngIf="!loading">
    <div *ngIf="otherApprovedPlanograms.length > 0" class="alert alert-warning">
      <div class="d-flex align-items-center mb-2">
        <i class="bi bi-exclamation-triangle-fill fs-4 me-2"></i>
        <strong>Warning: Existing Approved Planograms Found</strong>
      </div>
      <p>There are already approved planograms for this Store/Merchandise combination. Approving this planogram may overlap with the following:</p>
      
      <div class="list-group mt-3">
        <div *ngFor="let p of otherApprovedPlanograms" class="list-group-item list-group-item-action d-flex justify-content-between align-items-center">
          <div>
            <h6 class="mb-0">{{p.name}}</h6>
            <small class="text-muted">Published: {{p.datePublished | date:'short'}}</small>
          </div>
          <button class="btn btn-sm btn-outline-primary" (click)="openPlanogram(p)">
            View <i class="bi bi-box-arrow-up-right ms-1"></i>
          </button>
        </div>
      </div>
    </div>

    <div *ngIf="otherApprovedPlanograms.length === 0" class="text-center py-4">
      <div class="mb-3">
        <i class="bi bi-check-circle-fill text-success" style="font-size: 4rem;"></i>
      </div>
      <h5>Safe to Approve</h5>
      <p class="text-muted">No other approved planograms were found for this store and merchandise category.</p>
    </div>
      
    <div class="form-check mt-3 pt-3 border-top" *ngIf="otherApprovedPlanograms.length > 0">
      <input class="form-check-input" type="checkbox" id="unapproveOthers" [(ngModel)]="unapproveOthers">
      <label class="form-check-label fw-bold text-danger" for="unapproveOthers">
        Unapprove all existing planograms for this store & merchandise category
      </label>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary me-2" (click)="cancel()">Cancel</button>
  <button type="button" class="btn btn-success" [disabled]="loading" (click)="confirm()">
    Approve Planogram
  </button>
</div>